import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { BackendResponse, HttpService, ToastrService } from 'vas-mobile-api';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {

  public userId: string;
  public buttonEnabled = true;

  constructor(private httpService: HttpService,
    private toast: ToastrService,
    private dialogRef: MatDialogRef<PasswordResetComponent>) { }

  ngOnInit() {
  }

  public onSubmit() {
    this.buttonEnabled = false;
    this.httpService.get<BackendResponse<any>>(
      {
        pathId: 'requestPasswordReset', withToken: false, urlParams: { userId: this.userId }
      }).subscribe((response) => {
        this.toast.success(response.message);
        this.dialogRef.close();
      }, (e) => {
        this.buttonEnabled = true;
      });
  }

  public omit_special_char(event) {
    let c;
    c = event.charCode;  // k = event.keyCode;  (Both can be used)
    return ((c > 64 && c < 91) || (c > 96 && c < 123) || c === 8 || c === 32 || (c >= 48 && c <= 57));
  }

}
